import { LoginPage, SelectedShopPage } from 'features/auth';
import HomePage from 'features/home';
import SettingsPage from 'features/settings';
import { getToken } from 'helpers';
import { useAppDispatch, useAppSelector } from 'hooks';
import { useEffect } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import PublicRouter from 'routers/PublicRouter';
import { shopListAction } from 'slices/shopSlice';
import './assets/scss/index.scss';

import { PrivateRoutes } from 'components/Common';

const token = getToken();
function App() {
  const dispatch = useAppDispatch();
  const isMobileDevice = /Mobi/i.test(window.navigator.userAgent);

  const shopList = useAppSelector((state) => state.shopList.listShop);
  const isLoggedIn = useAppSelector((state) => state.auth.isLoggedIn);
  const masterInfo = useAppSelector((state) => state.auth.masterInfo);
  const selectShop = useAppSelector((state) => state.shopList.selectShop);
  const isMaster = masterInfo.active && !selectShop.id;
  useEffect(() => {
    (async () => {
      await localStorage.removeItem('bill_id');
    })();
  }, [dispatch]);
  useEffect(() => {
    document.head.innerHTML += isMobileDevice
      ? `<meta name="viewport" content="width=device-width, initial-scale=0.73 maximum-scale=0.73 user-scalable=0" />`
      : `<meta name="viewport"content="width=device-width, initial-scale=1 />`;
  }, [isMobileDevice]);
  return (
    <>
      <Routes>
        {/* Public Route */}

        {/* Protected Routes */}
        <Route element={<PrivateRoutes />}>
          {/* <Route path="/" element={<></>} /> */}
          {/* catch all route if error, always navigate to settings */}
          <Route path="*" element={<Navigate to={`/settings?tab=${isMaster ? 0 : 3}`} replace />} />
          <Route path="/settings" element={<SettingsPage />} />
          <Route path="/auth" element={<LoginPage />} />

          <Route path="/rank" element={<HomePage />} />
          <Route path="/select-shop" element={<SelectedShopPage />} />
        </Route>
      </Routes>
    </>
  );
}

export default App;
